// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"142cbe7c","551":"71d25103","617":"43c84db6","640":"5ed3a3fa","842":"7ff95b9e"}[chunkId] + ".chunk.js";
};